import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var TopShopTooltipContents = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(TooltipTypography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "MeUyyS",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "To earn Top Shop status, brands must:"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsxs("ul", {
                children: [
                    /*#__PURE__*/ _jsx(StyledListItem, {
                        children: /*#__PURE__*/ _jsx(TooltipTypography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "/9R8d/",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Earn a 4.8+ rating over the last 12 months"
                                    }
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(StyledListItem, {
                        children: /*#__PURE__*/ _jsx(TooltipTypography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "bJ/jcL",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Fulfill orders quickly & smoothly"
                                    }
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(StyledListItem, {
                        children: /*#__PURE__*/ _jsx(TooltipTypography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "gz5fML",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Run a world-class shop page"
                                    }
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(StyledListItem, {
                        children: /*#__PURE__*/ _jsx(TooltipTypography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "m2Td+g",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Maintain a fresh catalog"
                                    }
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var StyledListItem = styled.li.withConfig({
    componentId: "sc-6db4c7ae-0"
})([
    "list-style-type:disc;margin-left:",
    ";"
], getSpacing("3x"));
var TooltipTypography = styled(Typography).attrs({
    color: "inherit"
}).withConfig({
    componentId: "sc-6db4c7ae-1"
})([
    ""
]);
